(() => {
  'use strict';
  if (customElements.get('jonelia-sale-badge')) return;
  customElements.define('jonelia-sale-badge', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.scope = this.closest('[data-section-type="product"], [data-section-type="product-quick-view"]') || this.parentElement;
      this.onVariant = (event) => {
        const variant = event.detail && event.detail.variant;
        if (variant && this.variants.some(v => String(v.id) === String(variant.id))) this.show(variant.id);
        else requestAnimationFrame(() => {
          const input = this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
          if (input) this.show(input.value);
        });
      };
      this.scope.addEventListener('change', this.onVariant);
      this.scope.addEventListener('variant:changed', this.onVariant);
      this.show(this.dataset.variant);
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onVariant);
      this.scope?.removeEventListener('variant:changed', this.onVariant);
    }
    show(id) {
      const v = this.variants.find(v => String(v.id) === String(id));
      const pct = v && v.price > 0 && v.compare > v.price ? Math.floor((v.compare-v.price)*100/v.compare) : 0;
      this.hidden = pct < 1;
      this.querySelector('[data-sale-value]').textContent = this.dataset.presentation === 'text'
        ? this.dataset.label.replace('__percent__', `${pct}%`)
        : `−${pct}%`;
    }
  });
})();
